import React from 'react'

export const progressCheckColumns = (layout, role) => [
	{
		name: 'Order',
		selector: (row) => row.order,
		sortable: true,
		width: '10%'
	},
	{
		name: 'Description',
		selector: (row) => row.description || '',
		sortable: true,
		width: '50%',
		cell: (row) => <div className="text-truncate">{row.description || 'N/A'}</div>
	},
	{
		name: 'Type',
		selector: (row) => row.type || '',
		sortable: true,
		width: '15%'
	},
	{
		name: 'Score',
		selector: (row) => row.score,
		sortable: true,
		width: '10%'
	},
	{
		name: 'Actions',
		selector: (row) => row.id,
		sortable: false,
		width: '15%',
		cell: (row) => (
			<div className="d-flex gap-2">
				{row.onDelete && (
					<button className="btn btn-danger btn-sm" onClick={row.onDelete}>
						<i className="fa fa-trash"></i>
					</button>
				)}
			</div>
		)
	}
]
